import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=5e3da315&scoped=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"
import style0 from "./Table.vue?vue&type=style&index=0&id=5e3da315&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3da315",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e3da315')) {
      api.createRecord('5e3da315', component.options)
    } else {
      api.reload('5e3da315', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=5e3da315&scoped=true", function () {
      api.rerender('5e3da315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/Table.vue"
export default component.exports